import {Spinner} from '@/components/Spinner/Spinner.jsx'

export function LoadingPage() {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 220,
        color: 'var(--brand)',
      }}
    >
      <Spinner size={64} thickness={3}/>
    </div>
  )
}
